import { AppBar, Box, Button, Dialog, IconButton, Slide, Toolbar } from "@mui/material";
import React, { useEffect, useState } from "react";
import { TileLayer, useMapEvents, Marker, Popup, MapContainer } from 'react-leaflet'
import { ReactComponent as MapMarkerIcon } from "../Assets/svg/MapMarkerIcon.svg";
import { ReactComponent as ArrowRightIcon } from "../Assets/svg/ArrowRightIcon.svg";
import { ReactComponent as CloseIcon } from "../Assets/svg/CloseIcon.svg";
import http from '../api/axiosInstance';
import Cookies from 'js-cookie'

function MapEvent(props) {
     
    const map = useMapEvents({       
        zoom(){
            map.locate()
            console.log("zoom changed")
        }
    })
 
}

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function MapComponent(props) {

    const positionMap = [36.32386694335946, 59.579383705135136]
    const LatLongHandle = (latlng) => {
        console.log("🚀 ~ LatLongHandle ~ latlng:", latlng)
    }

    const [loading, setLoading] = useState(false)
    const [properties, setProperties] = useState([])

    const getLatLngHandle = () => {
        console.log("click")
    }
     
    useEffect(()=>{
        console.log("map")
    },[])

    const handleGetProps = async () => {
        setLoading(true)

        try {
            const response = await http({
                url: "/properties/get/list/by/filter",
                method: "POST",
                data: {
                    Latitude: positionMap[0],
                    Longitude: positionMap[1],
                    AgencyId: [Cookies.get('agency') && JSON.parse(Cookies.get('agency')).Id],
                    LocationId: Cookies.get('locationId') && Cookies.get('locationId'),
                    AgencyInfo: true,
                    LandLordInfo: true,
                },
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            });
            console.log(response);
            setProperties(response?.data?.result?.Properties)
        } catch (e) {
            console.error(e);

        }


        setLoading(false)
    }

 
 


    useEffect(() => {
        console.log("map is open")
        handleGetProps()
    }, [])

    return (<Dialog className="dialog-box"
        fullScreen
        open={props?.openMapModal}
        onClose={props?.handleCloseMapModal}
        TransitionComponent={Transition}
    >
        <AppBar sx={{ position: 'absolute', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
            <Toolbar >

                {/* <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                    انتخاب کنید
                </Typography> */}
                <Box sx={{ ml: 'auto' }}>
                    <Button
                        sx={{ backgroundColor: '#fff!important', ml: 2, borderRadius: "50px", color: '#8F8F8F', display: 'inline-flex', gap: '8px' }}
                    >نوع معامله
                        <ArrowRightIcon className='rotate-90' />
                    </Button>
                    <Button
                        sx={{ backgroundColor: '#fff!important', borderRadius: "50px", color: '#8F8F8F', display: 'inline-flex', gap: '8px' }}
                    >محدوده
                        <ArrowRightIcon className='rotate-90' />
                    </Button>
                </Box>
                <IconButton
                    edge="start"
                    color="inherit"
                    onClick={props?.handleCloseMapModal}
                    aria-label="close"
                    sx={{ backgroundColor: '#fff!important' }}
                >
                    <CloseIcon />
                </IconButton>
                {/* <Button autoFocus color="inherit" onClick={handleClose}>
                        save
                    </Button> */}
            </Toolbar>
        </AppBar>
        <Box sx={{ color: '#8F8F8F', display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px', height: '100%' }}>

            <MapContainer center={positionMap} zoom={13} scrollWheelZoom={false} className="h-100">
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />

                {properties?.length ?
                    properties?.map((item, index) => {
                        return <Marker key={index} position={positionMap}>
                            <Popup>
                                {item?.SalePrice}
                            </Popup>
                        </Marker>
                    }) : ""}

                    <MapEvent/>
            </MapContainer>
            {/* <Swiper
                dir="rtl"
                modules={[FreeMode]}
                slidesPerView={"auto"}
                spaceBetween={5}
                freeMode={true}
                className='map-slider'
            >
                <SwiperSlide>
                    <PropItem />
                </SwiperSlide>
                <SwiperSlide>
                    <PropItem />
                </SwiperSlide>
                <SwiperSlide>
                    <PropItem />
                </SwiperSlide>
                <SwiperSlide>
                    <PropItem />
                </SwiperSlide>
            </Swiper> */}
        </Box>

        {/* <Button className='green-btn'
            onClick={handleCloseMapModal}
            sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button> */}
    </Dialog>);
}

export default MapComponent;